module.exports = __webpack_public_path__ + "img/feature_02.e8ae1e7a.svg";